import { render, staticRenderFns } from "./handleOrdersTwoSweep.vue?vue&type=template&id=5c0ab642&scoped=true&"
import script from "./handleOrdersTwoSweep.vue?vue&type=script&lang=js&"
export * from "./handleOrdersTwoSweep.vue?vue&type=script&lang=js&"
import style0 from "./handleOrdersTwoSweep.vue?vue&type=style&index=0&id=5c0ab642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0ab642",
  null
  
)

export default component.exports